'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIAlert = require('UIComponents/alert/UIAlert');

var _UIAlert2 = _interopRequireDefault(_UIAlert);

var _components = require('I18n/components');

var _colors = require('HubStyleTokens/colors');

var _analytics = require('MeetingsLib/utils/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderAlert = function renderAlert(troubleshooting) {
  if (!troubleshooting) {
    return null;
  }
  return _react2.default.createElement(_UIAlert2.default, {
    className: 'm-x-auto m-bottom-2',
    type: 'info',
    style: { maxWidth: 575 },
    titleText: _react2.default.createElement(_components.FormattedMessage, { message: 'troubleshoot.alert' })
  });
};

var TroubleshootModeToggle = function TroubleshootModeToggle(_ref) {
  var compact = _ref.compact,
      canTroubleshoot = _ref.canTroubleshoot,
      troubleshooting = _ref.troubleshooting,
      toggleTroubleshootMode = _ref.toggleTroubleshootMode;

  if (!canTroubleshoot) {
    return null;
  }
  var troubleshootMessageKey = troubleshooting ? 'troubleshoot.exit' : 'troubleshoot.enter';

  if (troubleshooting) {
    (0, _analytics.loadTroubleshootModeTallyCampaign)();
  }

  var classes = (0, _reactUtils.classNames)('p-top-4 text-center', { 'p-bottom-4': compact });

  return _react2.default.createElement(
    'div',
    { className: classes, style: { background: _colors.GYPSUM } },
    renderAlert(troubleshooting),
    _react2.default.createElement(
      _UIButton2.default,
      {
        onClick: function onClick() {
          return toggleTroubleshootMode(!troubleshooting);
        },
        use: 'link',
        'data-selenium-test': 'troubleshoot-button'
      },
      _react2.default.createElement(_components.FormattedMessage, { message: troubleshootMessageKey })
    )
  );
};

TroubleshootModeToggle.propTypes = {
  canTroubleshoot: _react.PropTypes.bool.isRequired,
  troubleshooting: _react.PropTypes.bool.isRequired,
  toggleTroubleshootMode: _react.PropTypes.func.isRequired
};

exports.default = TroubleshootModeToggle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/header/TroubleshootModeToggle.js
// module id = 491
// module chunks = 0